module.exports = __webpack_public_path__ + "img/courier-purolatorfreight.df45a939.svg";